import React, {useState, useEffect} from 'react'
import Template from '../component/template'
import {LoadEffect, TableLoader}  from '../component/loader'
import axios from 'axios'
import { Alerts, WarningModal } from '../component/notify'
import PageHeader from '../component/pageheader'
import { ServerUrl, Token, config } from '../component/include'

import BootstrapTable from 'react-bootstrap-table-next';
import cellEditFactory from 'react-bootstrap-table2-editor';
import {Type} from 'react-bootstrap-table2-editor';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';

 const FeeType =()=>{   
    const Initials = {
        ID: "", 
        fees: "", 
        status: "true"
    }
const [errors, setErrors] = useState({});
const [data, setData] =  useState([]);
const [isSubmitting, setIsSubmitting] = useState(false);    
const [feetype, setFeetype] = useState(Initials);
const [notice, setNotice] = useState({
    isLoading : false, 
    isDataFetching: false,
}); 

    const validateInput =(values)=>{
    let errors = {};     
    if(!values.fees){
        errors.fees ='Fees Type field is required';
    }
    if (data.filter(item=>item.fees.toLowerCase() ===values.fees.toLowerCase()).length!==0){
        errors.fees ='Fee type already exist';
    }

    return errors;
    }


const handleSubmit =(event)=>{
    event.preventDefault();
    setErrors(validateInput(feetype));
    setIsSubmitting(true);
}


const handleReset = ()=>{
    setFeetype(Initials);
}

function submit(){
   
    setNotice({...notice, isLoading: true}) 

     let formData = feetype; 
     const fd = new FormData();
     fd.append('jwt', Token); 
        for(let k in formData){
            fd.append(k,formData[k]);
        }; 

         let url = ServerUrl+'/save_controller/tbl_fee_type'
        axios.post(url, fd, config)
        .then(response =>{
            if (response.data.type ==='success'){
                Alerts('Saved!', 'success', response.data.message)
            } else{
                Alerts('Error!', 'danger', JSON.stringify(response.data))
        }  
        })
        .catch((error)=>{
            Alerts('Error!', 'danger', JSON.stringify(error.message)) 
        })
        .finally(()=>{
          setNotice({...notice, isLoading: false}) 
        handleReset(); 
        setIsSubmitting(false)
        handleFetchData()
        }) 
    
}

const  handleFetchData =()=>{
    const fd = new FormData();
            fd.append('jwt', Token);
    let url = ServerUrl + '/fetch_controller/tbl_fee_type'
    setNotice({...notice,  isDataFetching: true });
    axios.post(url, fd, config)
    .then(result =>setData(result.data))
    .catch((error)=>{
        Alerts('Error!', 'danger', JSON.stringify(error.message)) 
    }).finally(()=>{
        setNotice({...notice, 
            isDataFetching: false
        })
    })    
        }


useEffect(()=>{
    if(Object.keys(errors).length === 0 && isSubmitting){
    submit()
    }
},[errors])



useEffect(()=>{
    handleFetchData();
},[]);


const handleDelete = (feeID)=>{  
    setNotice({...notice, isLoading: true}) 
       let close =   document.getElementById('btnWarningDialog-'+feeID)
          close.click();
          const fd = new FormData();
          fd.append('jwt', Token);
       fd.append('ID', 'ID')
		fd.append('data', feeID)

        let url = ServerUrl+'/delete_controller/tbl_fee_type'
       axios.post(url, fd, config)
       .then(response =>{
        if(response.data.type ==='success'){
           Alerts('Saved!', 'success', response.data.message)
               } else{
           Alerts('Error!', 'danger', JSON.stringify(response.data))
               }   
       })
       .catch((error)=>{
         Alerts('Error!', 'danger', error.message)
       }).finally(()=>{
           handleFetchData()
           setNotice({...notice, 
               isLoading: false
           })
       }) 
}


const handleCheckbox =()=>{
const value = feetype.status ==='true'? 'false':'true';
 setFeetype({...feetype, status : value});
}



const handleChange =(event)=>{
    const {name, value} = event.target
    setFeetype({...feetype, [name] : value});
    setErrors({...errors, [name]:''})
}

 
const tableFeeHeader = [
    {dataField: 'fees',  text: 'Fees', validator: (newValue, row, column) => {
        if (!newValue) {
          return {
            valid: false,
            message: 'Fees Name is required'
          };
        }
        return true;
      }, formatter:(cell)=><div style={{maxWidth:'250px',  overflowWrap:'break-word', whiteSpace:'pre-wrap' }}>{cell}</div> },
     
    {dataField: 'status', text: 'Active', sort: true, editor: {
                type: Type.SELECT, options:[{value:'true', label:'Active'},
                {value:'false', label:'Inactive'}]
              }, formatter:(cell)=>cell==='true'? <div className="text-center"><i title="Double click to change" className="fa fa-check badge-inverse-success"></i></div>: <div className="text-center"><i title="Double click to change" className="fa fa-times badge-inverse-danger"></i></div>},

    {dataField: 'ID', text: 'Action', formatter: (cell)=><div>
         <WarningModal  handleAction={()=>handleDelete(cell)} mID={cell} message='Once deleted, you will no be able to recover this record. Are you realy sure?' />
         <button type="button" className="btn btn-danger btn-sm delete" data-toggle="modal"   data-target={`#warningdialog-${cell}`} title="Delete"><i className="fa fa-trash"></i></button>
         
         </div>, editable: false}
 ];


const TableRecord=(props)=>{

const handleUpdate=(column, newValue, ID)=>{       
    const fd = new FormData();
            fd.append('jwt', Token); 
        fd.append('newValue', newValue);
        fd.append('column', column.dataField);
        fd.append('ID', ID);
      
       let url = ServerUrl+'/updateCustom_controller/tbl_fee_type'
      axios.post(url, fd, config)
      //.then(result => console.log(result.data))
      .then()
      .catch((error)=>Alerts('Error!', 'danger', error.message)) 
    } 


     const { SearchBar } = Search;
     
     const customTotal = (from, to, size) => (
        <span >&nbsp;Showing { from } to { to } of { size } items</span>
      );
     const options = {
        showTotal: true,
      paginationTotalRenderer: customTotal,
      sizePerPageList: [{text: '100', value: 100}, {text: '200', value: 200}, {text: '500', value: 500}, {text: '1000', value: 1000},
      { text: 'All', value: props.data.length }]
       
      };
     return  <ToolkitProvider search columnToggle 
                 keyField='ID' data={ props.data } columns={ props.columns } >
                     
                     {
                         props => (
                         <div >
                           <div className="form-group">
                             <SearchBar
                             { ...props.searchProps } style={{height:'40px'}} className="form-control" placeholder="Type to search!!!" />
                                              
 </div>
                             
                 <BootstrapTable
                             { ...props.baseProps }
                                         striped
                                     hover
                                     condensed
                                     noDataIndication={<div className="alert alert-danger background-danger">No Record Found</div>}
                                 pagination={paginationFactory(options) }
                                 cellEdit={ cellEditFactory({
                                   mode: 'dbclick',
                                   blurToSave: true,
                                   autoSelectText: true,
                         beforeSaveCell: (oldValue, newValue, row, column) => {
                           if(oldValue !==newValue){
                           handleUpdate(column, newValue, row.ID);
                           
                          return true;
                         }
                         
                       }
                                 }) }
                             />
                         </div>
                         )
                     }
  </ToolkitProvider>
  }
        
        return (  <>
   {notice.isLoading ?<LoadEffect className="floatLoad overlay" /> : "" } 
   <div  className="main-body">
                <div className="page-wrapper">  
                   {/* <!-- Page-header start --> */}

        <PageHeader title="Fees Type">
        <li className="breadcrumb-item"><a  href="#!"> <i className="fa fa-fw fa-money"></i> </a>
                            </li>
                            <li className="breadcrumb-item"><a href="#!">Fees</a> </li>

<li className="breadcrumb-item"><a href="#!">Fees Type</a> </li>
                    </PageHeader>
{/* The Page Body start here */}
                <div className="page-body">              

                <div className="row  ">
				<div className="col-sm-5">
<div className="card z-depth-0">
		<div className="card-header">
			<h5><i className="fa fa-edit" ></i> Add Fee Type</h5>
			<div className="card-header-right">
				<ul className="list-unstyled card-option">
					<li><i className="feather icon-maximizes full-card"></i></li>
					<li><i className="feather icon-minus minimize-card"></i></li>
					<li><i className="feather icon-trash-2 close-card"></i></li>
				</ul>
			</div>
		</div>
	<div className="card-block">
		<fieldset>
            <div className="row">	
            <section className="col-md-12">
            <div className="form-group">
                        <label >Fee Type Name<span style={{color:'red'}}>*</span></label>
                        <input type='text' onChange={handleChange} id='fees' name='fees' value={feetype.fees} className={`form-control ${errors.fees?'form-control-danger':''}`} placeholder='Fee Type Name' />
                                    
            </div>
            <span style={{color:'red'}}>{errors.fees && errors.fees}</span>
            </section>
        </div>
 
        <div className="row">
            <section className="col-md-12">
            <div className="checkbox-color checkbox-primary">
        <input id="status"  name="status" type="checkbox" onChange={handleCheckbox} checked={feetype.status==='true'? true:false} />
                <label htmlFor="status">Active</label>
            </div>	
            </section>
        </div>
        <hr/>
     </fieldset>


        <footer className="pull-right">
       
        <button onClick={handleSubmit} className='btn btn-inverse'  type="button" >Save</button>

        </footer>				
    </div>
</div>
</div>

    <div className="col-sm-7">
    <div className="card z-depth-0">
        <div className="card-header">
            <h5>Listing All Fee Type</h5>
            <div className="card-header-right">
                <ul className="list-unstyled card-option">
                    <li><i className="feather icon-maximizes  full-card"></i></li>
                    <li><i className="feather icon-minus minimize-card"></i></li>
                    <li><i className="feather icon-trash-2 close-card"></i></li>
                </ul>
            </div>
        </div>

        

<div className="card-block">
<div className="col-md-12 table-responsive">

        {notice.isDataFetching ? 
        <TableLoader />:
        <TableRecord data={data} fetchdata={handleFetchData} columns={tableFeeHeader}  />
        }
</div></div>
</div>
</div>

</div>
</div>
          {/* The Page Body close here */}

            </div>
            </div>

</> 
 );
        }


export default React.memo(FeeType)